export interface ExternalUserAnalyticsProvider {
  Provider: React.ComponentType<{ children: React.ReactNode }>
  useFeatureFlagEnabled: (flag: string) => boolean | undefined
}

interface UserAnalyticsProvider<T extends string> {
  UserAnalyticsProvider: React.ComponentType<{ children: React.ReactNode }>
  useIsFeatureEnabled: (flag: T) => boolean | undefined
}

export function makeUserAnalytics<Flags extends string>(
  provider: ExternalUserAnalyticsProvider,
): UserAnalyticsProvider<Flags> {
  return {
    UserAnalyticsProvider: provider.Provider,
    useIsFeatureEnabled: provider.useFeatureFlagEnabled,
  }
}
